/** Project contract (RBAC area: `projects`). A project belongs to a customer. */
export const PROJECT_STATUSES = ['active', 'on_hold', 'completed', 'cancelled'];
//# sourceMappingURL=project.js.map